import React from 'react';
import { connect } from 'react-redux';

import MaterialSelector from '../../../../components/MaterialSelector/index';
import SquarePlates from '../../SquarePlates/index';
import {
  setProfileMaterial,
  setProfileFamily,
  setProfileSize,
  setBracketAttachmentActiveBtn
} from '@reducers/selectors/application/actions';
import { APP_TYPES } from '@config';

const BracketAttachment = props => (
  <div className="calculation">
    <section className="list-type">
      <SquarePlates buttons={props.squareButtons} activeBtn={props.activeBtn} onUpdate={props.setSquareBtn}/>

      <MaterialSelector
        material={props.profileMaterial}
        onMaterialSelect={props.onProfileMaterialSelect}
        family={props.profileFamily}
        onFamilySelect={props.onProfileFamilySelect}
        size={props.profileSize}
        onSizeSelect={props.onProfileSizeSelect}
      />
    </section>
  </div>
);

const mapState = state => ({
  squareButtons: state.selectors.application.bracketButtons.buttons,
  activeBtn: state.selectors.application[APP_TYPES.BRACKET_ATTACHMENT].activeBtn,

  profileMaterial: state.selectors.application[APP_TYPES.BRACKET_ATTACHMENT].profile.material,
  profileFamily: state.selectors.application[APP_TYPES.BRACKET_ATTACHMENT].profile.family,
  profileSize: state.selectors.application[APP_TYPES.BRACKET_ATTACHMENT].profile.size
});

const mapDispatch = dispatch => ({
  setSquareBtn: item => dispatch(setBracketAttachmentActiveBtn(item.id)),

  onProfileMaterialSelect: value => dispatch(setProfileMaterial(value)),
  onProfileFamilySelect: value => dispatch(setProfileFamily(value)),
  onProfileSizeSelect: value => dispatch(setProfileSize(value))
});

export default connect(mapState, mapDispatch)(BracketAttachment);



// WEBPACK FOOTER //
// ./src/views/Application/types/BracketAttachment/index.js